import { ColumnModel, FilterModel } from '../../filter';

export const FileFilterKey = 'FILE_FILTER';
export const FileOrderKey = 'FILE_ORDER';

export const FileFilterColumns = [
  'productsCount',
  'assetsCount',
  'addonsCount',
  'categories',
  'updatedAt',
  'createdAt',
];

export class FileFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  workspaceId: string;
  columns?: string[];
  categoryIds?: string[];
  orderBy?: string;

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.workspaceId = data?.workspaceId;
    this.columns = data?.columns || FileFilterColumns;
    this.categoryIds = data?.categoryIds;
    this.orderBy = data?.orderBy;
  }

  public getColumnsCount(): number {
    return this.columns && this.columns.length > 0 ? this.columns.length : 0;
  }

  public getCategoriesCount(): number {
    return this.categoryIds && this.categoryIds.length > 0 ? this.categoryIds.length : 0;
  }

  public getGraphQLFilter(): any {
    const filter = {} as any;

    if (this.keyword) {
      filter.keyword = this.keyword;
    }
    if (this.workspaceId) {
      filter.workspaceId = this.workspaceId;
    }
    if (this.categoryIds && this.categoryIds.length > 0) {
      filter.categoryIds = this.categoryIds;
    }
    return filter;
  }
}
